export const whenPurchasedData = {
  title: 'When did your broadband contract begin?',
  imgObj: {
    alt: '',
    src: 'https://media.product.which.co.uk/prod/images/original/aea862695be0-tooliconcalendar.jpg',
  },
}
